'use client';

import { useQuery } from '@tanstack/react-query';
import { api } from '../api/endpoints';

export function useStatus() {
  return useQuery({
    queryKey: ['status'],
    queryFn: api.getStatus,
    refetchInterval: 10_000,
  });
}
